package ai.jessie.web.settings

import ai.jessie.shared.settings.VatRateProposal
import ai.jessie.web.theme.FormStackStyle
import ai.jessie.web.theme.Grid3Style
import androidx.compose.runtime.Composable
import com.varabyte.kobweb.silk.style.toAttrs
import org.jetbrains.compose.web.dom.Div

@Composable
internal fun vatCard(state: SettingsUiState, actions: SettingsActions) {
    val draft = state.draft ?: return
    groupCard(
        "MWST-Versionen",
        vatGuidance(state.current?.currentDate),
        attrs = {
            // Focus target when a problem concerns the stored versions as a whole.
            id("settings-vatRates")
            attr("tabindex", "-1")
        },
    ) {
        draft.vatRates.forEachIndexed { index, row ->
            val stored = state.current?.vatRates?.firstOrNull { it.vatRateId == row.vatRateId }
            if (stored != null && !stored.editable) {
                hint(
                    "${stored.name}: ${stored.rate} %, ${stored.effectiveFrom} bis " +
                        "${stored.effectiveTo ?: "offen"} (unveränderlich)"
                )
            } else {
                Div(attrs = FormStackStyle.toAttrs()) {
                    vatRow(index, row, state) { update ->
                        actions.change { it.copy(vatRates = it.vatRates.updated(index, update)) }
                    }
                    if (row.vatRateId == null)
                        smallAction("Neue MWST-Version ${index + 1} verwerfen", state.busy) {
                            actions.change {
                                it.copy(vatRates = it.vatRates.filterIndexed { i, _ -> i != index })
                            }
                        }
                }
            }
        }
        smallAction("MWST-Version hinzufügen", state.busy) {
            actions.change { it.copy(vatRates = it.vatRates + VatRateProposal("", "", "")) }
        }
    }
}

// A3, BR-178: stated before any error occurs.
private fun vatGuidance(currentDate: String?) =
    "Neue Versionen beginnen frühestens am $currentDate (Organisationszeitzone). Gleichnamige " +
        "Zeiträume dürfen sich nicht überschneiden. Begonnene Versionen bleiben unverändert. " +
        "Bei geplanten Versionen passt der Server das Ende der Vorgängerversion an."

@Composable
private fun vatRow(
    index: Int,
    row: VatRateProposal,
    state: SettingsUiState,
    change: ((VatRateProposal) -> VatRateProposal) -> Unit,
) {
    val prefix = "vatRates[$index]"
    fun field(part: String, label: String, value: String) =
        SettingsField(
            "$prefix.$part",
            "MWST ${index + 1}: $label",
            value,
            state.problems["$prefix.$part"],
        )
    Div(attrs = Grid3Style.toAttrs()) {
        settingsField(field("name", "Name (1–50 Zeichen)", row.name)) {
            change { row -> row.copy(name = it) }
        }
        settingsField(field("rate", "Satz (0–100, höchstens zwei Dezimalstellen)", row.rate)) {
            change { row -> row.copy(rate = it) }
        }
        settingsField(field("effectiveFrom", "Gültig ab (JJJJ-MM-TT)", row.effectiveFrom)) {
            change { row -> row.copy(effectiveFrom = it) }
        }
    }
    if (row.vatRateId != null)
        settingsSelect(
            SettingsField(
                "$prefix.remove",
                "Geplante MWST-Version ${index + 1}",
                row.remove.toString(),
                state.problems["$prefix.remove"],
            ),
            mapOf("false" to "Behalten", "true" to "Entfernen"),
        ) {
            change { row -> row.copy(remove = it == "true") }
        }
}
